import type { AgentConnectionResponse } from '@contract-analyzer/api-client';

import { tenantPath } from '@/lib/routes';

/**
 * The prompt introduces itself only on the calm landing pages of a workspace,
 * never over a result grid or an editor where it would interrupt work.
 */
export function isAgentConnectionAutoOpenPage(pathname: string, tenantSlug: string | null): boolean {
  if (tenantSlug === null) {
    return false;
  }
  const normalized = pathname.length > 1 ? pathname.replace(/\/+$/u, '') : pathname;
  return normalized === tenantPath(tenantSlug) || normalized === tenantPath(tenantSlug, '/projects');
}

export interface AgentConnectionAutoOpenInput {
  readonly connection: AgentConnectionResponse | null;
  readonly onAutoOpenPage: boolean;
  /** Release news is loading or has been shown during this page load. */
  readonly releaseNewsPending: boolean;
  readonly alreadyAutoOpened: boolean;
}

export function shouldAutoOpenAgentConnection({
  connection,
  onAutoOpenPage,
  releaseNewsPending,
  alreadyAutoOpened,
}: AgentConnectionAutoOpenInput): boolean {
  return (
    connection !== null &&
    connection.eligible &&
    connection.prompt.should_auto_open &&
    onAutoOpenPage &&
    !releaseNewsPending &&
    !alreadyAutoOpened
  );
}
